import { render, staticRenderFns } from "./DelegationInfoExchangeRateView.vue?vue&type=template&id=739aa7d8&scoped=true&"
import script from "./DelegationInfoExchangeRateView.vue?vue&type=script&lang=js&"
export * from "./DelegationInfoExchangeRateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739aa7d8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VDataTable,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('739aa7d8')) {
      api.createRecord('739aa7d8', component.options)
    } else {
      api.reload('739aa7d8', component.options)
    }
    module.hot.accept("./DelegationInfoExchangeRateView.vue?vue&type=template&id=739aa7d8&scoped=true&", function () {
      api.rerender('739aa7d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delegation-info/DelegationInfoExchangeRateView.vue"
export default component.exports